import axios from '../_utils/axios';

// ----------------------------------------------------------------------

const getSoilDashboards = async (groupId) => {
  return await axios.get(`soil-dashboards/groups/${groupId}`)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default getSoilDashboards;